import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpRequestService } from 'src/app/common-services/http-request.service';
import { UserInfoService } from 'src/app/common-services/user-info.service';
import { NotificationService } from 'src/app/common-services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
	notifications: any;
	authInfo
	pagination: any;
	next_btn: string;
	back_btn: string;
	singleData: any;
	constructor(private http: HttpRequestService, private toastr: ToastrService, private userInfo: UserInfoService, private route: Router, private notificationService: NotificationService, public translate: TranslateService) { }

	getNotificationText(item: any, field: 'title' | 'body' = 'body'): string {
		if (!item) return '';
		const currentLang = this.translate.currentLang || localStorage.getItem('lang') || 'en-US';
		if (item.translated && Array.isArray(item.translated) && item.translated.length > 0) {
			const langMatch = item.translated.find((t: any) => t.lang === currentLang);
			if (langMatch && langMatch[field]) {
				return langMatch[field];
			}
		}
		return item[field] || '';
	}

	ngOnInit(): void {
		this.authInfo = this.userInfo.userInfo()
		if (this.authInfo) {

			this.getNotification()
		}

	}



	getNotification() {
		this.http.request('get', '/notification/get-in-app-notification/?user_id=' + this.authInfo.user_id, null).subscribe(res => {
			this.pagination = res.data
			let data = res.data.results;
			this.notifications = data;
			var next_ = this.pagination.next;
			var back_ = this.pagination.previous;
			if (next_) {
				this.next_btn = "false";
			}
			if (back_) {
				this.back_btn = "false";

			}
		})
	}

	showNotification(item) {
		this.http.request('get', '/notification/get-in-app-notification/?user_id=' + this.authInfo.user_id + '&id=' + item, null).subscribe(res => {
			this.singleData = res.data.results[0];
		});

		this.http.request('patch', '/notification/read-in-app-notification/' + item, null).subscribe(res => {
			this.notificationService.triggerNotificationCountRefresh();
		})

	}

	deleteNotification(id) {
		this.http.request('patch', '/notification/delete-in-app-notification/' + id, null).subscribe(res => {
			this.toastr.success("Notification Deleted Successfully")
			this.getNotification();
			this.notificationService.triggerNotificationCountRefresh();
		})
	}


	/////////////////////////////////////////////////
	// next and periviouse button data load
	/////////////////////////////////////////////////
	preiviouseData() {
		let str = this.pagination.previous;
		var split = str.split('/');
		var url = '/';
		for (let i = 3; i < split.length; i++) {
			url += split[i] + '/'
		}
		var apiUrl = url.substr(0, url.length - 1);

		this.http.request('get', '' + apiUrl, null).subscribe(res => {
			this.pagination = res.data;
			this.notifications = this.pagination.results;
			var next_ = this.pagination.next;
			var back_ = this.pagination.previous;
			if (next_) {
				this.next_btn = "false";
			}
			if (back_) {
				this.back_btn = "false";

			}

		})

	}


	nextData() {
		let str = this.pagination.next;
		var split = str.split('/');

		var url = '/';
		for (let i = 3; i < split.length; i++) {
			url += split[i] + '/'
		}
		var apiUrl = url.substr(0, url.length - 1);

		this.http.request('get', '' + apiUrl, null).subscribe(res => {

			this.pagination = res.data;

			this.notifications = this.pagination.results;

			var next_ = this.pagination.next;
			var back_ = this.pagination.previous;
			if (next_) {
				this.next_btn = "false";
			}
			if (back_) {
				this.back_btn = "false";

			}

		})


	}
	public count: any;
	viewClick(webPath, notificationId) {
		this.http.request('patch', '/notification/read-in-app-notification/' + notificationId, null).subscribe(res => {
			this.http.request('get', '/notification/get-in-app-notification/?user_id=' + this.authInfo['user_id'], null).subscribe(res => {
				let data = res.data.results;
				// let filterData = data.filter(item => item.is_read == false)
				if (data.length > 0) {
					this.count = data[0].pending_count;
					//this.cdr.detectChanges();
				}
			})
			this.notificationService.triggerNotificationCountRefresh();
			let targetUrl = webPath;
			if (targetUrl) {
				let pathWithoutQuery = targetUrl;
				let queryString = '';
				if (targetUrl.includes('?')) {
					const parts = targetUrl.split('?');
					pathWithoutQuery = parts[0];
					queryString = '?' + parts.slice(1).join('?');
				}
				const pathSegments = pathWithoutQuery.split('/');
				const lastSegment = pathSegments[pathSegments.length - 1];
				if (/^\d+$/.test(lastSegment)) {
					pathSegments[pathSegments.length - 1] = btoa(lastSegment);
					targetUrl = pathSegments.join('/') + queryString;
				}
			}
			this.route.navigateByUrl(targetUrl);
		})
	}

	clearNotifications() {
		let url = 'notification/clear-all-in-app-notifications/' + this.authInfo.user_id;

		this.http.request('patch', url, null).subscribe(res => {
			this.toastr.success("Notification Cleared Successfully")
			this.getNotification();
			this.notificationService.triggerNotificationCountRefresh();
		})
	}

}
